howspace.widgets.quizz = (() => {
    'use strict';

    const getCharacter = (number) => {
        return String.fromCharCode(number % 26 + 65);
    };

    const updateCharacters = (widget) => {
        const checkbox = widget.find('.show-answer-markers-checkbox');

        if (checkbox.prop('checked')) {
            widget.find('.quizz-option-character').removeClass('d-none');
        } else {
            widget.find('.quizz-option-character').addClass('d-none');
        }

        widget.find('.quizz-options .quizz-option').each(function(i, option) {
            $(option).find('.quizz-option-character').html(getCharacter(i));
        });
    };

    return {
        save: (widget, dataPayload) => {
            dataPayload.quizz_options = [];

            const quizzOptions = widget.find('.quizz-options .howspace-sortable-list-item:not(.deleted)').toArray();

            quizzOptions.forEach((option) => {
                dataPayload.quizz_options.push(real.form.getDataPayload($(option)));
            });

            return dataPayload;
        },
        initView: widget => {

            const submitQuizzAnswer = function(option) {

                const dataPayload = {
                    selected_options : [
                        option.data('quizz-option-id')
                    ]
                };

                real.ajax.json(real.baseUri + '/api/widget/quizz/' + widget.data('widget-id') + '/quizzanswers', {
                    type : 'POST',
                    data : JSON.stringify(dataPayload),
                    success : function(response) {
                        option.dataAndAttr('is-selected', true);
                        widget.dataAndAttr('has-user-answered', true);
                        widget.dataAndAttr('answer-id', response.quizzanswer.id);
                        howspace.workspace.page.pathMode.handleUserHasInteracted(widget);
                    },
                    logError : function(response) {
                        return response.status !== 409;
                    },
                    showErrorNotification : function(response) {
                        return response.status !== 409;
                    },
                    error : function(response) {
                        real.ajax.loopErrors(response, function(error) {
                            if(error.code === 409) {
                                // User has already answered to quizz, but UI didn't update fast enough and now
                                // user is trying to answer again and conflict occurred. Just update the
                                // whole widget UI at this point.
                                howspace.widgets.updateWidget(widget, 'view');
                            }
                        });
                    }
                });
            };

            const deleteQuizzAnswer = function(widget, submitNewAnswerFn) {

                real.ajax.json(real.baseUri + '/api/widget/quizz/' + widget.data('widget-id') + '/quizzanswer/' + widget.data('answer-id'), {
                    type : 'DELETE',
                    success : () => {
                        const selectedOption = widget.find('.widget-content .quizz-options .quizz-option[data-is-selected="true"]');
                        selectedOption.dataAndAttr('is-selected', false);

                        widget.dataAndAttr('has-user-answered', false);

                        if (typeof submitNewAnswerFn === 'function') {
                            if (selectedOption.attr('aria-controls')) {
                                // User had answered, and now clicked on another option. We need to collapse the
                                // previously selected option before submitting the new answer.
                                howspace.components.collapse.toggle(selectedOption);
                            }

                            submitNewAnswerFn();
                        }
                    }
                });
            }

            widget.find('.widget-content .quizz-options').on('click keypress', '.quizz-option:not(.disabled)', function(e) {
                const option = $(this);

                if (option.data('has-feedback')) {
                    // Prevent clicking on the feedback area of the quizz option causing the option to toggle.
                    if ($(e.target).closest('.quizz-option-feedback').length) {
                        return;
                    }

                    if (option.attr('aria-expanded') === 'true') {
                        howspace.components.collapse.collapse(option);
                    } else {
                        howspace.components.collapse.expand(option);
                    }
                }

                // TODO: fix me!
                // This is a workaround solution for keyboard accessibility problem
                // The check above will skip the handle if the keypress is not "Space" or "Enter"
                // This is a temporal solution until the problem is handled on framework / component level.
                if(e.type === 'keypress'){
                    var code = e.charCode || e.keyCode;
                    if((code !== 32) && (code !== 13)){
                        return;
                    }
                }

                const isOptionSelected = option.data('is-selected');
                const hasUserAnswered = widget.data('has-user-answered');

                if (!hasUserAnswered) {
                    submitQuizzAnswer(option);
                } else if (hasUserAnswered && !isOptionSelected) {
                    deleteQuizzAnswer(widget, () => {
                        submitQuizzAnswer(option);
                    });
                } else if (hasUserAnswered && isOptionSelected) {
                    deleteQuizzAnswer(widget);
                } else {
                    console.error('Unknown state: ', widget);
                }
            });
        },
        destroyView: widget => {
            // Empty for now.
        },
        initEdit: widget => {

            const enableRightWrongAnswers = (widget) => {
                widget.find('.quizz-options .quizz-option-wrapper').each(function(i, optionWrapper) {
                    $(optionWrapper).find('.quizz-option-is-correct').removeClass('d-none');

                    // Mark the first option as correct by default
                    if (i === 0) {
                        $(optionWrapper).find('input[name="is_correct"]').prop('checked', true);
                        $(optionWrapper).find('.quizz-option').addClass('quizz-option-correct');
                    } else {
                        $(optionWrapper).find('.quizz-option').addClass('quizz-option-wrong');
                    }
                });

                let template = widget.find('template.sortable-item').contents();
                template.find('.quizz-option-is-correct').removeClass('d-none');

                widget.find('.options-label').addClass('d-none');
                widget.find('.options-label-with-instructions').removeClass('d-none');
            };

            const disableRightWrongAnswers = (widget) => {
                widget.find('.quizz-options .quizz-option-wrapper').each(function(i, optionWrapper) {
                    $(optionWrapper).find('.quizz-option-is-correct').addClass('d-none');
                    $(optionWrapper).find('.quizz-option').removeClass('quizz-option-correct');
                    $(optionWrapper).find('.quizz-option').removeClass('quizz-option-wrong');
                    $(optionWrapper).find('input[name="is_correct"]').prop('checked', false);
                });

                let template = widget.find('template.sortable-item').contents();
                template.find('.quizz-option-is-correct').addClass('d-none');

                widget.find('.options-label').removeClass('d-none');
                widget.find('.options-label-with-instructions').addClass('d-none');
            };

            widget.find('.use-right-and-wrong-answers-checkbox').on('change', (e) => {
                let checkbox = e.currentTarget;

                if (checkbox.checked) {
                    enableRightWrongAnswers(widget);
                } else {
                    disableRightWrongAnswers(widget);
                }
            });

            widget.find('.show-answer-markers-checkbox').on('change', (e) => {
                const checkbox = $(e.currentTarget);
                const widget = checkbox.closest('.widget');

                updateCharacters(widget);
            })

            widget.on('change', 'input[name="is_correct"]', (e) => {
                let checkbox = $(e.currentTarget);

                let optionWrapper = checkbox.closest('.quizz-option-wrapper');

                if (checkbox.prop('checked')) {
                    optionWrapper.find('.quizz-option').removeClass('quizz-option-wrong');
                    optionWrapper.find('.quizz-option').addClass('quizz-option-correct');
                } else {
                    optionWrapper.find('.quizz-option').removeClass('quizz-option-correct');
                    optionWrapper.find('.quizz-option').addClass('quizz-option-wrong');
                }
            });

            widget.on(howspace.components.sortableList.ITEM_MOVED, () => {
                updateCharacters(widget);
            });

            // Add option button.
            widget.find('.add-option-btn').on('click', () => {
                widget.find('.quizz-options').removeClass('d-none');

                const sortableList = widget.find('.howspace-sortable-list');
                const option = howspace.components.sortableList.addItem(sortableList);

                if (widget.find('.show-answer-markers-checkbox').prop('checked')) {
                    const optionIndex = widget.find('.quizz-options .quizz-option').length - 1;
                    option.find('.quizz-option-character').html(getCharacter(optionIndex));
                } else {
                    option.find('.quizz-option-character').addClass('d-none');
                }

                if (widget.find('.use-right-and-wrong-answers-checkbox').prop('checked')) {
                    option.find('.quizz-option').addClass('quizz-option-wrong');
                }
            });

            updateCharacters(widget);
        },
        destroyEdit: widget => {
            // Empty for now.
        }
    };
})();
